import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
// import productItems from 'src/app/data/products';
import { ColumnMode, DatatableComponent, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CrudService } from '../../../environments/crud.service';
import { environment } from '../../../environments/environment';
import { apis } from '../../../environments/apis';
import { view_seccion } from '../../../environments/seccions'
import { seccions } from './seccions'
// import { global } from '../global'
import { saveAs } from 'file-saver';
// Moneda en input
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
// import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import Swal from 'sweetalert2';
import { NgSelectComponent } from '@ng-select/ng-select';

// Notificaciones
// import { NotificationsService, NotificationType } from 'angular2-notifications';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./tables.component.css'],
  providers: [CrudService, CurrencyPipe]
})
export class TablesComponent implements OnInit {
  public idmodal = 0
  public total = 0
  public ciclos = []
  public ciclo:any = localStorage.getItem('ciclo') ? parseInt(localStorage.getItem('ciclo')) : []
  public areas = []
  public area:any = localStorage.getItem('area') ? parseInt(localStorage.getItem('area')) : []

  tipo_de_usuario = sessionStorage.getItem('tipo_de_usuario')
  // Paginacion
  paginas = []
  pagina_actual:any = '1'
  SortType = SortType;
  public filteredData = [];
  public data = [];

  public view_seccion: string;
  public de_fecha: string;
  public hasta_fecha: string;
  public status: string;

  public token: string;
  public negocio: string;
  public id: number;

  public rows: Array<any>;
  public columns: Array<{ prop?: string, name: string }>;
  public ColumnMode;
  public temp: Array<any>;
  public itemsPerPage: number;
  public itemOptionsPerPage: Array<number>;

  public selected: Array<any>;
  public SelectionType;
  public selectAllState: string;
  // Modal confirmar eliminar
  public modalRef: BsModalRef;
  public message: string;

  public totales: Array<{ label: string, monto: string }> = [];

  public excluded_edit = []
  windowWidth = window.innerWidth - 400
  scrollBarHorizontal = (window.innerWidth < 1200);
  real_seccion = "";

  @Input() agregar;
  @Input() seccion;
  @Input() id_agregar;
  @Input() is_tab;
  @Input() seccion_agregar;
  @Input() atras;
  @ViewChild('ciclosSelect') ciclosSelect:NgSelectComponent;
  @ViewChild('areaSelect') areaSelect:NgSelectComponent;
  @ViewChild(DatatableComponent) table: DatatableComponent;

  file:any;
  have_lees_pages = false
  have_more_pages = false
  siguiente = 2
  regresar = 1
  total_de_paginas = 0
  busqueda =  ''
  api:any

  fileSeccion:any;
  nombre: any;
  constructor(
    // private modalService: BsModalService,
    private route: ActivatedRoute,
    private crud: CrudService,
    private router: Router,
    // private notifications: NotificationsService,
    private currencyPipe: CurrencyPipe,
    private modalService: BsModalService
  ) {

  }

  ngOnInit() {
    this.pagina_actual = localStorage.getItem('pagina_actual') || 1
    this.busqueda = localStorage.getItem('busqueda') || ''
    if (this.scrollBarHorizontal) {
      this.windowWidth = window.innerWidth - 120
    }
    if (this.atras && !this.excluded_edit.includes(this.seccion)) {
      localStorage.setItem('atras', this.atras)
      
    }
    else {
      localStorage.removeItem('atras')

    }

    window.onresize = () => {
      this.scrollBarHorizontal = (window.innerWidth < 1200);
      this.windowWidth = window.innerWidth
    };

    this.token = sessionStorage.getItem("token");
    this.negocio = sessionStorage.getItem("negocio");
    this.id = 0;

    this.route.params.subscribe((params) => {
      this.real_seccion = params.seccion
      // alert(params.seccion)
      // alert(this.seccion_agregar)
      this.columns = [];
      this.rows = [];
      this.data = [];
      this.filteredData = [];
      if (this.is_tab && this.seccion) {
        this.view_seccion = view_seccion[this.seccion];
        this.windowWidth = window.innerWidth - 400
        
      }
      else {
        this.seccion = params.seccion;
        this.view_seccion = this.seccion in view_seccion ? view_seccion[this.seccion] : this.seccion;
        
      }
      this.api = this.seccion in apis ? apis[this.seccion] : this.seccion
      let datos = {
        tipo_de_usuario: this.tipo_de_usuario,
        is_admin: true,
        ciclo:this.ciclo,
        area:this.area,
      }
      if (this.id_agregar) {
        datos['id'] = this.id_agregar
      }


      Swal.fire({
        title: 'Cargando datos',
        onBeforeOpen () {
          Swal.showLoading ()
        },
        onAfterClose () {
          Swal.hideLoading()
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton:false
      })
      if(this.seccion == 'ventas'){
        datos['id'] = params.id
        this.id = params.id
        localStorage.setItem('atras', 'ventas/'+params.id)
      }
      this.crud.getData(this.api+"?page="+this.pagina_actual+'&busqueda='+this.busqueda, this.token, datos).subscribe(
        response => {
          this.total = response.total
          this.total_de_paginas = response.paginas
          if(response.paginas <= 10){
            let keys = []
            this.paginas = [...Array(response.paginas).keys()]
            this.have_more_pages = false;
            this.have_lees_pages = false;
            
          }
          else{
            this.paginas = []
            if(parseInt(response.pagina_actual) > 6 ){
              if((this.total_de_paginas - response.pagina_actual) >= 6){
                for (let i = parseInt(response.pagina_actual)-6; i < parseInt(response.pagina_actual)+5; i++) {
                  this.paginas.push(i);
                }
                this.have_more_pages = true;
                this.have_lees_pages = true;
                this.atras = parseInt(response.pagina_actual)-6
                this.siguiente = parseInt(response.pagina_actual)+6
                
              }
              else{
                for (let i = parseInt(response.pagina_actual)-6; i < this.total_de_paginas; i++) {
                  this.paginas.push(i);
                }
                this.have_more_pages = false;
                this.have_lees_pages = true;
                this.atras = parseInt(response.pagina_actual)-6

              }
              
            }
            else{
              for (let i = 0; i < parseInt(response.pagina_actual)+5; i++) {
                this.paginas.push(i);
                
              }
              this.have_more_pages = true;
              this.have_lees_pages = false;
              this.siguiente = parseInt(response.pagina_actual)+6

            }

          }
          // this.paginas = [...Array(response.paginas).keys()]
          this.pagina_actual = parseInt(response.pagina_actual)
          this.totales = response.totales;
          for (let field in seccions[this.seccion]) {
            this.columns.push({ prop: field.replace(/\_/g, ""), name: seccions[this.seccion][field] });
          }
          let arr = []
          for (let row of response.data) {
            let datos = {}
            for (let key in row) {
              datos[key.replace(/\_/g, "")] = row[key]
            }
            arr.push(datos)
          }
          this.rows = [...arr];

          for (let row of this.rows) {
            row["acciones"] = row["id"];

            // Verifica los foreignkey, primero verifica si existe nombre si no busca title y si no encuentra ninguno pone el id
            for (let field in row) {
              if (typeof row[field] == "object" && row[field]) {
                if ("name" in row[field]) {
                  row[field] = row[field]["name"]
                }
                else if ("title" in row[field]) {
                  row[field] = row[field]["title"]
                }
                else if ("nombre" in row[field]) {
                  row[field] = row[field]["nombre"]
                }
                else if ("titulo" in row[field]) {
                  row[field] = row[field]["titulo"]
                }
                else {
                  row[field] = row[field]["id"]

                }

              }

              if (typeof row[field] == "string") {
                if (row[field].includes(".jpg") | row[field].includes(".png") | row[field].includes(".jpeg")) {
                  // alert()
                  let image = '<img src="' + environment.apiUrl + "storage/" + row[field] + '" width="100">';
                  row[field] = image;
                  // let image = document.createElement("img");
                  // image.setAttribute("src", row[field]);
                  // row[field] = image;
                }

              }
            }

          }

          this.data = this.rows;
          this.filteredData = this.data;
          Swal.close()
          
        },
        error => {
          Swal.close()

        }
      )

      this.ColumnMode = ColumnMode;
      this.temp = [...this.rows];
      this.itemsPerPage = 10;
      this.itemOptionsPerPage = [5, 10, 20];
      this.selected = [];
      this.SelectionType = SelectionType;
      this.selectAllState = '';
    });
  }

  isNumber(val, key, tootip = false) {
    let ret
    if(tootip && typeof val === "boolean"){
      return ''
    }
    if (key.includes("precio") || key.includes("costo") || key.includes("importe")) {
      ret = this.currencyPipe.transform(val, "$")
    }
    if (key.includes("porcentaje")) {
      ret = this.currencyPipe.transform(val, "").replace(/\$/g, "")+'%'
    }
    else if (Number(val) && key != "id" && key != "orden" && key != 'numerocliente' && key != "orgventas" && key != "anio" && key != "numerodecliente" && key != "codigo" && key != "aplicados" && key != "telefono" && key != "control" && key != "claveal" && key != "clave" && key != "cuenta" && key != "ciclo" && key != "cicloinicio") {
      if (val.toString() != "true" && val.toString() != "false") {
        ret = this.currencyPipe.transform(val, "").replace(/\$/g, "")
      }
      else {
        if (val.toString() == "true") {
          ret = '<i class="material-icons text-success ml-5">done</i>'
        }
        else {
          ret = '<i class="material-icons text-danger ml-5">highlight_off</i>'

        }
      }

    }
    else {
      if(val === null){
        ret = ''
      }
      else if (val && val.toString() != "true" && val.toString() != "false") {
        ret = val
      }
      else {
        if (val && val.toString() == "true") {
          ret = '<i class="material-icons text-success ml-5">done</i>'
        }
        else {
          ret = '<i class="material-icons text-danger ml-5">highlight_off</i>'

        }
      }


    }
    // alert(ret)
    return ret;
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase().trim();
    const count = this.columns.length;
    const keys = Object.keys(this.temp[0]);
    const temp = this.temp.filter(item => {
      for (let i = 0; i < count; i++) {
        if ((item[keys[i]] && item[keys[i]].toString().toLowerCase().indexOf(val) !== -1) || !val) {
          return true;
        }
      }
    });
    this.rows = temp;
    this.table.offset = 0;
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
    this.setSelectAllState();
  }

  setSelectAllState() {
    if (this.selected.length === this.rows.length) {
      this.selectAllState = 'checked';
    } else if (this.selected.length !== 0) {
      this.selectAllState = 'indeterminate';
    } else {
      this.selectAllState = '';
    }
  }

  selectAllChange($event) {
    if ($event.target.checked) {
      this.selected = [...this.rows];
    } else {
      this.selected = [];
    }
    this.setSelectAllState();
  }

  onItemsPerPageChange(itemCount) {
    this.itemsPerPage = itemCount;
  }

  openModal(template: TemplateRef<any>, seccion = this.seccion, id = this.idmodal) {
    this.idmodal = id;
    // alert(this.idmodal );
    this.fileSeccion = seccion
    this.modalRef = this.modalService.show(template, { class: '' });
  }
  // Eliminar
  // openModal(id) {
  //   this.id = id;
  //   this.crud.deleteData(this.token, this.seccion, this.id).subscribe(
  //     response => {
  //       this.removeByAttr(this.data, 'id', this.id)
  //       Swal.fire('¡Genial!', 'Ha sido eliminado correctamente', 'success');
  //     }
  //   )

  // }

  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (arr[i]
        && arr[i].hasOwnProperty(attr)
        && (arguments.length > 2 && arr[i][attr] === value)) {

        arr.splice(i, 1);

      }
    }
    return arr;
  }

  removeAll(event) {
    for (let select of this.selected) {
      this.crud.deleteData(this.token, this.seccion, select.id).subscribe(
        response => {
          this.removeByAttr(this.rows, 'id', select.id);
        }
      )

    }
    // this.notifications.create('¡Genial!', "Ha sido eliminado los elementos seleccionados correctamente", NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
  }

  fileChanged(e) {
    this.file = e.target.files[0];
  }

  confirm(input): void {
    console.log(this.file)
    // let data = {file:form.controls['file'].value};
    Swal.fire({
      title: 'Cargando datos',
      onBeforeOpen () {
        Swal.showLoading ()
      },
      onAfterClose () {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton:false
    })
    let data = {}
    data['nombre'] = this.nombre
    data['de_fecha'] = this.de_fecha
    data['hasta_fecha'] = this.hasta_fecha
    this.crud.postData(this.fileSeccion+"/", this.token, data).subscribe(
      response => {
        // this.notifications.create('¡Genial!', "Ha sido eliminado correctamente", NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
        this.removeByAttr(this.rows, 'id', this.id);
        this.rows = [... this.rows];
        // alert(this.seccion_agregar)
        this.columns = [];
        this.rows = [];
        this.data = [];
        this.filteredData = [];
        let datos = {
          is_admin: true,
        }
        if (this.id_agregar) {
          datos['id'] = this.id_agregar
        }
        if(this.seccion == 'ventas'){
          datos['id'] = this.id
        }
        this.crud.getData(this.api+"?page=1", this.token, datos).subscribe(
          response => {
            this.total_de_paginas = response.paginas
          if(response.paginas <= 10){
            this.paginas = [...Array(response.paginas).keys()]
            this.have_more_pages = false;
            this.have_lees_pages = false;
            
          }
          else{
            this.paginas = []
            if(parseInt(response.pagina_actual) > 6 ){
              if((this.total_de_paginas - response.pagina_actual) >= 6){
                for (let i = parseInt(response.pagina_actual)-6; i < parseInt(response.pagina_actual)+5; i++) {
                  this.paginas.push(i);
                }
                this.have_more_pages = true;
                this.have_lees_pages = true;
                this.atras = parseInt(response.pagina_actual)-6
                this.siguiente = parseInt(response.pagina_actual)+6
                
              }
              else{
                for (let i = parseInt(response.pagina_actual)-6; i < this.total_de_paginas; i++) {
                  this.paginas.push(i);
                }
                this.have_more_pages = false;
                this.have_lees_pages = true;
                this.atras = parseInt(response.pagina_actual)-6

              }
              
            }
            else{
              for (let i = 0; i < parseInt(response.pagina_actual)+5; i++) {
                this.paginas.push(i);
                
              }
              this.have_more_pages = true;
              this.have_lees_pages = false;
              this.siguiente = parseInt(response.pagina_actual)+6

            }

          }
          // this.paginas = [...Array(response.paginas).keys()]
          this.pagina_actual = parseInt(response.pagina_actual)
          this.totales = response.totales;
            for (let field in seccions[this.seccion]) {
              this.columns.push({ prop: field.replace(/\_/g, ""), name: seccions[this.seccion][field] });
            }
            let arr = []
            for (let row of response.data) {
              let datos = {}
              for (let key in row) {
                datos[key.replace(/\_/g, "")] = row[key]
              }
              arr.push(datos)
            }
            this.rows = [...arr];

            for (let row of this.rows) {
              row["acciones"] = row["id"];

              // Verifica los foreignkey, primero verifica si existe nombre si no busca title y si no encuentra ninguno pone el id
              for (let field in row) {
                if (typeof row[field] == "object" && row[field]) {
                  if ("name" in row[field]) {
                    row[field] = row[field]["name"]
                  }
                  else if ("title" in row[field]) {
                    row[field] = row[field]["title"]
                  }
                  else if ("nombre" in row[field]) {
                    row[field] = row[field]["nombre"]
                  }
                  else if ("titulo" in row[field]) {
                    row[field] = row[field]["titulo"]
                  }
                  else {
                    row[field] = row[field]["id"]

                  }

                }

                if (typeof row[field] == "string") {
                  if (row[field].includes(".jpg") | row[field].includes(".png") | row[field].includes(".jpeg")) {
                    // alert()
                    let image = '<img src="' + environment.apiUrl + "storage/" + row[field] + '" width="100">';
                    row[field] = image;
                    // let image = document.createElement("img");
                    // image.setAttribute("src", row[field]);
                    // row[field] = image;
                  }

                }
              }

            }

            this.data = this.rows;
            this.filteredData = this.data;
          },
          error => {

          }
        )

        this.ColumnMode = ColumnMode;
        this.temp = [...this.rows];
        this.itemsPerPage = 10;
        this.itemOptionsPerPage = [5, 10, 20];
        this.selected = [];
        this.SelectionType = SelectionType;
        this.selectAllState = '';
        Swal.close()
        this.modalRef.hide();
      },
      error => {
        console.log("error", error);
        Swal.close()
        let alert = ""
        for(let e in error.error){
          alert += e+": "+error.error[e]
        }
        Swal.fire('¡Oops!', alert);
        this.modalRef.hide();
      }
    )

  }

  decline(): void {
    // this.message = 'Declined!';
    this.modalRef.hide();
  }

  exportExcel(event) {
    this.crud.exportExcel(this.token, this.seccion).subscribe(
      response => {
        console.log(response)
        const blob = new Blob([response], { type: 'application/octet-stream' });
        saveAs(blob, this.seccion + '.xlsx');
      }
    )
  }

  filterDatatable(event, filtro=false) {
    if ((!filtro && event.keyCode === 13) || filtro) {
      // this.busqueda = val
      this.columns = [];
      this.rows = [];
      this.data = [];
      this.filteredData = [];
      if(this.busqueda){
        localStorage.setItem('busqueda', this.busqueda)
      }
      else{
        localStorage.removeItem('busqueda')
      }
      if(this.ciclo){
        localStorage.setItem('ciclo', this.ciclo)
      }
      else{
        localStorage.removeItem('ciclo')
      }
      if(this.area){
        localStorage.setItem('area', this.area)
      }
      else{
        localStorage.removeItem('area')
  
      }
      localStorage.setItem('pagina_actual', "1")
      let datos = {
        is_admin: true,
        tipo_de_usuario:this.tipo_de_usuario,
        ciclo:this.ciclo,
        area:this.area
      }
      if (this.id_agregar) {
        datos['id'] = this.id_agregar
      }
      if(this.seccion == 'ventas'){
        datos['id'] = this.id
      }
      this.crud.getData(this.api+"?busqueda="+this.busqueda, this.token, datos).subscribe(
        response => {
          this.total = response.total
          this.total_de_paginas = response.paginas
            if(response.paginas <= 10){
              this.paginas = [...Array(response.paginas).keys()]
              this.have_more_pages = false;
              this.have_lees_pages = false;
              
            }
            else{
              this.paginas = []
              if(parseInt(response.pagina_actual) > 6 ){
                if((this.total_de_paginas - response.pagina_actual) >= 6){
                  for (let i = parseInt(response.pagina_actual)-6; i < parseInt(response.pagina_actual)+5; i++) {
                    this.paginas.push(i);
                  }
                  this.have_more_pages = true;
                  this.have_lees_pages = true;
                  this.atras = parseInt(response.pagina_actual)-6
                  this.siguiente = parseInt(response.pagina_actual)+6
                  
                }
                else{
                  for (let i = parseInt(response.pagina_actual)-6; i < this.total_de_paginas; i++) {
                    this.paginas.push(i);
                  }
                  this.have_more_pages = false;
                  this.have_lees_pages = true;
                  this.atras = parseInt(response.pagina_actual)-6

                }
                
              }
              else{
                for (let i = 0; i < parseInt(response.pagina_actual)+5; i++) {
                  this.paginas.push(i);
                  
                }
                this.have_more_pages = true;
                this.have_lees_pages = false;
                this.siguiente = parseInt(response.pagina_actual)+6

              }

            }
            // this.paginas = [...Array(response.paginas).keys()]
            this.pagina_actual = parseInt(response.pagina_actual)
            this.totales = response.totales;
          for (let field in seccions[this.seccion]) {
            this.columns.push({ prop: field.replace(/\_/g, ""), name: seccions[this.seccion][field] });
          }
          let arr = []
          for (let row of response.data) {
            let datos = {}
            for (let key in row) {
              datos[key.replace(/\_/g, "")] = row[key]
            }
            arr.push(datos)
          }
          this.rows = [...arr];

          for (let row of this.rows) {
            row["acciones"] = row["id"];

            // Verifica los foreignkey, primero verifica si existe nombre si no busca title y si no encuentra ninguno pone el id
            for (let field in row) {
              if (typeof row[field] == "object" && row[field]) {
                if ("name" in row[field]) {
                  row[field] = row[field]["name"]
                }
                else if ("title" in row[field]) {
                  row[field] = row[field]["title"]
                }
                else if ("nombre" in row[field]) {
                  row[field] = row[field]["nombre"]
                }
                else if ("titulo" in row[field]) {
                  row[field] = row[field]["titulo"]
                }
                else {
                  row[field] = row[field]["id"]

                }

              }

              if (typeof row[field] == "string") {
                if (row[field].includes(".jpg") | row[field].includes(".png") | row[field].includes(".jpeg")) {
                  // alert()
                  let image = '<img src="' + environment.apiUrl + "storage/" + row[field] + '" width="100">';
                  row[field] = image;
                  // let image = document.createElement("img");
                  // image.setAttribute("src", row[field]);
                  // row[field] = image;
                }

              }
            }

          }

          this.data = this.rows;
          this.filteredData = this.data;
        },
        error => {

        }
      )

      this.ColumnMode = ColumnMode;
      this.temp = [...this.rows];
      this.itemsPerPage = 10;
      this.itemOptionsPerPage = [5, 10, 20];
      this.selected = [];
      this.SelectionType = SelectionType;
      this.selectAllState = '';
    }
  }

  getPage(number){
    // TODO: Revisar que cuando en el buscador haya texto la paginacion se envie con el buscador
    this.columns = [];
    this.rows = [];
    this.data = [];
    this.filteredData = [];
    if(this.busqueda){
      localStorage.setItem('busqueda', this.busqueda)
    }
    else{
      localStorage.removeItem('busqueda')
    }
    if(this.ciclo){
      localStorage.setItem('ciclo', this.ciclo)
    }
    else{
      localStorage.removeItem('ciclo')
    }
    if(this.area){
      localStorage.setItem('area', this.area)
    }
    else{
      localStorage.removeItem('area')

    }
    localStorage.setItem('pagina_actual', number.toString())
    let datos = {
      is_admin: true,
      tipo_de_usuario:this.tipo_de_usuario,
      area:this.area,
      ciclo:this.ciclo,
    }
    if (this.id_agregar) {
      datos['id'] = this.id_agregar
    }
    if(this.seccion == 'ventas'){
      datos['id'] = this.id
    }
    this.crud.getData(this.api+"?busqueda="+this.busqueda+"&page="+number, this.token, datos).subscribe(
      response => {
        this.total = response.total
        this.total_de_paginas = response.paginas
        if(response.paginas <= 10){
          this.paginas = [...Array(response.paginas).keys()]
          this.have_more_pages = false;
          this.have_lees_pages = false;
          
        }
        else{
          this.paginas = []
          if(parseInt(number) > 6 ){
            if((this.total_de_paginas - number) >= 6){
              for (let i = parseInt(number)-6; i < parseInt(number)+5; i++) {
                this.paginas.push(i);
              }
              this.have_more_pages = true;
              this.have_lees_pages = true;
              this.atras = parseInt(number)-6
              this.siguiente = parseInt(number)+6
              
            }
            else{
              for (let i = parseInt(number)-6; i < this.total_de_paginas; i++) {
                this.paginas.push(i);
              }
              this.have_more_pages = false;
              this.have_lees_pages = true;
              this.atras = parseInt(number)-6

            }
            
          }
          else{
            for (let i = 0; i < parseInt(number)+5; i++) {
              this.paginas.push(i);
              
            }
            this.have_more_pages = true;
            this.have_lees_pages = false;
            this.siguiente = parseInt(number)+6

          }

        }
        // this.paginas = [...Array(response.paginas).keys()]
        this.pagina_actual = parseInt(number)
        this.totales = response.totales;
        for (let field in seccions[this.seccion]) {
          this.columns.push({ prop: field.replace(/\_/g, ""), name: seccions[this.seccion][field] });
        }
        let arr = []
        for (let row of response.data) {
          let datos = {}
          for (let key in row) {
            datos[key.replace(/\_/g, "")] = row[key]
          }
          arr.push(datos)
        }
        this.rows = [...arr];

        for (let row of this.rows) {
          row["acciones"] = row["id"];

          // Verifica los foreignkey, primero verifica si existe nombre si no busca title y si no encuentra ninguno pone el id
          for (let field in row) {
            if (typeof row[field] == "object" && row[field]) {
              if ("name" in row[field]) {
                row[field] = row[field]["name"]
              }
              else if ("title" in row[field]) {
                row[field] = row[field]["title"]
              }
              else if ("nombre" in row[field]) {
                row[field] = row[field]["nombre"]
              }
              else if ("titulo" in row[field]) {
                row[field] = row[field]["titulo"]
              }
              else {
                row[field] = row[field]["id"]

              }

            }

            if (typeof row[field] == "string") {
              if (row[field].includes(".jpg") | row[field].includes(".png") | row[field].includes(".jpeg")) {
                // alert()
                let image = '<img src="' + environment.apiUrl + "storage/" + row[field] + '" width="100">';
                row[field] = image;
                // let image = document.createElement("img");
                // image.setAttribute("src", row[field]);
                // row[field] = image;
              }

            }
          }

        }

        this.data = this.rows;
        this.filteredData = this.data;
      },
      error => {

      }
    )

    this.ColumnMode = ColumnMode;
    this.temp = [...this.rows];
    this.itemsPerPage = 10;
    this.itemOptionsPerPage = [5, 10, 20];
    this.selected = [];
    this.SelectionType = SelectionType;
    this.selectAllState = '';
  }

  confirmDelete(value){
    let datos = {
      negocio: this.negocio,
      is_admin: true,
    }
    if (this.id_agregar) {
      datos['id'] = this.id_agregar
    }
    if(this.seccion == 'ventas'){
      datos['id'] = this.id
    }
    this.crud.deleteData(this.token, this.seccion, value).subscribe(
      response => {
        this.columns = []
        this.crud.getData(this.api, this.token, datos).subscribe(
          response => {
            this.total_de_paginas = response.paginas
            this.total = response.total;
            if(response.paginas <= 10){
              this.paginas = [...Array(response.paginas).keys()]
              this.have_more_pages = false;
              this.have_lees_pages = false;
              
            }
            else{
              this.paginas = []
              if(parseInt(response.pagina_actual) > 6 ){
                if((this.total_de_paginas - response.pagina_actual) >= 6){
                  for (let i = parseInt(response.pagina_actual)-6; i < parseInt(response.pagina_actual)+5; i++) {
                    this.paginas.push(i);
                  }
                  this.have_more_pages = true;
                  this.have_lees_pages = true;
                  this.atras = parseInt(response.pagina_actual)-6
                  this.siguiente = parseInt(response.pagina_actual)+6
                  
                }
                else{
                  for (let i = parseInt(response.pagina_actual)-6; i < this.total_de_paginas; i++) {
                    this.paginas.push(i);
                  }
                  this.have_more_pages = false;
                  this.have_lees_pages = true;
                  this.atras = parseInt(response.pagina_actual)-6
  
                }
                
              }
              else{
                for (let i = 0; i < parseInt(response.pagina_actual)+5; i++) {
                  this.paginas.push(i);
                  
                }
                this.have_more_pages = true;
                this.have_lees_pages = false;
                this.siguiente = parseInt(response.pagina_actual)+6
  
              }
  
            }
            // this.paginas = [...Array(response.paginas).keys()]
            this.pagina_actual = parseInt(response.pagina_actual)
            this.totales = response.totales;
            for (let field in seccions[this.seccion]) {
              this.columns.push({ prop: field.replace(/\_/g, ""), name: seccions[this.seccion][field] });
            }
            let arr = []
            for (let row of response.data) {
              let datos = {}
              for (let key in row) {
                datos[key.replace(/\_/g, "")] = row[key]
              }
              arr.push(datos)
            }
            this.rows = [...arr];
  
            for (let row of this.rows) {
              row["acciones"] = row["id"];
  
              // Verifica los foreignkey, primero verifica si existe nombre si no busca title y si no encuentra ninguno pone el id
              for (let field in row) {
                if (typeof row[field] == "object" && row[field]) {
                  if ("name" in row[field]) {
                    row[field] = row[field]["name"]
                  }
                  else if ("title" in row[field]) {
                    row[field] = row[field]["title"]
                  }
                  else if ("nombre" in row[field]) {
                    row[field] = row[field]["nombre"]
                  }
                  else if ("titulo" in row[field]) {
                    row[field] = row[field]["titulo"]
                  }
                  else {
                    row[field] = row[field]["id"]
  
                  }
  
                }
  
                if (typeof row[field] == "string") {
                  if (row[field].includes(".jpg") | row[field].includes(".png") | row[field].includes(".jpeg")) {
                    // alert()
                    let image = '<img src="' + environment.apiUrl + "storage/" + row[field] + '" width="100">';
                    row[field] = image;
                    // let image = document.createElement("img");
                    // image.setAttribute("src", row[field]);
                    // row[field] = image;
                  }
  
                }
              }
  
            }
  
            this.data = this.rows;
            this.filteredData = this.data;
            Swal.close()
          },
          error => {
            Swal.close()
  
          }
        )
        Swal.fire('Genial', 'Eliminado correctamente')
      }
    )
  }
  reporteExcel(seccion){
    Swal.fire({
      title: 'Cargando datos',
      onBeforeOpen () {
        Swal.showLoading ()
      },
      onAfterClose () {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton:false
    })
    this.crud.exportExcel(this.token, seccion).subscribe(
      response => {
        console.log("response", response);
        const blob = new Blob([response], { type: 'application/octet-stream' });
        saveAs(blob, 'reporte_'+this.seccion+'.xlsx');
        Swal.close()
      },
      error => {
        Swal.close()
      }
    )

  }
  
  reportePDF(seccion, data){
    Swal.fire({
      title: 'Cargando datos',
      onBeforeOpen () {
        Swal.showLoading ()
      },
      onAfterClose () {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton:false
    })
    this.crud.exportPDF(this.token, seccion, data).subscribe(
      response => {
        console.log("response", response);
        const blob = new Blob([response], { type: 'application/pdf' });
        saveAs(blob, 'reporte_'+seccion+'.pdf');
        Swal.close()
      },
      error => {
        Swal.fire('¡Oops!',error.error);
        Swal.close()
      }
    )

  }

  reporte(url){
    Swal.fire({
      title: 'Generando reporte',
      onBeforeOpen () {
        Swal.showLoading ()
      },
      onAfterClose () {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton:false
    })
    this.crud.getFile(url, this.token, {}).subscribe(
      response => {  
        let blob = new Blob([response], { type: 'application/pdf'});
        let fileURL = window.URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
        Swal.close()
        
      },
      error => {
        console.log("error", error);
        Swal.close()
        Swal.fire('Ocurrio un error')

      }
    )
  }

}